import { useAllowAnonymousEdit } from "@src/components/board/mutations/allow-anonymous-edit";
import { useCloseIntake } from "@src/components/board/mutations/close-intake";
import { useDenyAnonymousEdit } from "@src/components/board/mutations/deny-anonymous-edit";
import { useOpenIntake } from "@src/components/board/mutations/open-intake";
import { usePublishWhiteboard } from "@src/components/board/mutations/publish-whiteboard";
import { useUnpublishWhiteboard } from "@src/components/board/mutations/unpublish-whiteboard";
import { useAllowCloneWhiteboard } from "../../board/mutations/allow-clone-whiteboard";
import { useDenyCloneWhiteboard } from "../../board/mutations/deny-clone-whiteboard";

export function useShareWhiteboardMutations() {
	const { mutateAsync: publishWhiteboard, isPending: isPublishing } =
		usePublishWhiteboard();
	const { mutateAsync: unpublishWhiteboard, isPending: isUnpublishing } =
		useUnpublishWhiteboard();
	const { mutateAsync: allowCloneWhiteboard, isPending: isAllowingClone } =
		useAllowCloneWhiteboard();
	const { mutateAsync: denyCloneWhiteboard, isPending: isDenyingClone } =
		useDenyCloneWhiteboard();
	const {
		mutateAsync: allowAnonymousEdit,
		isPending: isAllowingAnonymousEdit,
	} = useAllowAnonymousEdit();
	const { mutateAsync: denyAnonymousEdit, isPending: isDenyingAnonymousEdit } =
		useDenyAnonymousEdit();
	const { mutateAsync: openIntake, isPending: isOpeningIntake } =
		useOpenIntake();
	const { mutateAsync: closeIntake, isPending: isClosingIntake } =
		useCloseIntake();

	const isLoading =
		isPublishing ||
		isUnpublishing ||
		isAllowingClone ||
		isDenyingClone ||
		isAllowingAnonymousEdit ||
		isDenyingAnonymousEdit ||
		isOpeningIntake ||
		isClosingIntake;

	return {
		mutations: {
			publishWhiteboard,
			unpublishWhiteboard,
			allowCloneWhiteboard,
			denyCloneWhiteboard,
			allowAnonymousEdit,
			denyAnonymousEdit,
			openIntake,
			closeIntake,
		},
		isLoading,
	};
}
